import React from "react";
import { Button, Space } from "antd";

interface ModeButtonsProps {
  shadowMode: string | null;
  setShadowMode: (mode: string) => void;
}

const FREE = "FREE";
const PRE_REGISTER = "PRE-REGISTER NOT ACTIVE";
const PAYMENT = "PAYMENT NOT ACTIVE";
const NOT_CONFIGURED = "NOT CONFIGURED";

const ModeButtons: React.FC<ModeButtonsProps> = ({ shadowMode, setShadowMode }) => {
  return (
    <Space>
      <Button type={shadowMode === FREE ? "primary" : "default"}
              onClick={() => setShadowMode(FREE)}>
        {"Free"}
      </Button>

      <Button type={shadowMode === PRE_REGISTER ? "primary" : "default"}
              onClick={() => setShadowMode(PRE_REGISTER)}>
        {"Pre-register"}
      </Button>

      <Button type={shadowMode === NOT_CONFIGURED ? "primary" : "default"}
              onClick={() => setShadowMode(NOT_CONFIGURED)}>
        {"Not configured"}
      </Button>

      <Button type={shadowMode === PAYMENT ? "primary" : "default"}
              onClick={() => setShadowMode(PAYMENT)}>
        {"Payment"}
      </Button>
    </Space>
  );
};

export default ModeButtons;